import { render, staticRenderFns } from "./err401.vue?vue&type=template&id=1e11f5a4&"
import script from "./err401.vue?vue&type=script&lang=js&"
export * from "./err401.vue?vue&type=script&lang=js&"
import style0 from "./err401.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports